module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-flow-03-03e7c9fc1dc38d5f19393ccbfa3b3737.png";